import PoolInfo from './pool-info';

export default PoolInfo;
